import React from "react"
import {
  InputContainer,
  LabelRow,
  Label,
  FieldText,
  FormRow,
  InputWithLabel,
  ErrorMessage,
} from "./common"
import { Required } from "buoy-input"
import { Dropdown } from "buoy-core"
import { toolTipText } from "../UserDetailsFormConfig"
import { options, getOptText, formatDate } from "../userDetailsUtilities"
import { responsive } from "../../../common/styledHelpers"
import { ToolTip } from "../CardSubSection"
// 4851-todo: update responsive helper

const Basic = ({
  dirty,
  edit,
  selected,
  payForm,
  first,
  last,
  sex,
  birthday,
  birthdayNeeded,
  month,
  day,
  year,
  onFocus,
  onBlur,
  onChangeInput,
  onChangeDropdown,
}) => {
  const ageYear = year.edited
    ? year.value
    : selected.year || new Date().getFullYear() - selected.age

  return (
    <React.Fragment>
      <FormRow isEditing={dirty}>
        <InputWithLabel
          isEditing={dirty}
          edit={edit}
          maxLength="32"
          onFocus={onFocus("first")}
          onBlur={onBlur("first")}
          showError={first.edited && !first.valid && !first.isActive}
          error={first.error}
          label="First name"
          onChange={onChangeInput("first")}
          value={
            first.edited
              ? first.value
              : selected.first_name || selected.first_name
          }
          required
        />
        <InputWithLabel
          isEditing={dirty}
          edit={edit}
          maxLength="32"
          onFocus={onFocus("last")}
          onBlur={onBlur("last")}
          showError={last.edited && !last.valid && !last.isActive}
          error={last.error}
          label="Last name"
          onChange={onChangeInput("last")}
          value={last.edited ? last.value : selected.last_name}
          required
        />

        <InputContainer
          paddingBottom={
            dirty
              ? "padding-bottom: 24px"
              : responsive("padding-bottom", "24px", "20px")
          }
        >
          <LabelRow>
            <Label>
              Sex<Required />
            </Label>
            {dirty && <ToolTip message={toolTipText.sex} />}
          </LabelRow>
          {dirty ? (
            <Dropdown
              noMargin
              options={options.sex}
              placeholder="Select One"
              showError={payForm && !sex.valid}
              error={sex.error}
              value={
                sex.edited
                  ? sex.value
                  : !selected.sex
                    ? ""
                    : selected.sex === "m" ? "male" : "female"
              }
              onChange={onChangeDropdown("sex")}
            />
          ) : (
            <FieldText>
              {getOptText(
                "sex",
                sex.value === "m"
                  ? "male"
                  : sex.value === "f" ? "female" : null,
                !selected.sex ? "" : selected.sex === "m" ? "male" : "female"
              )}
            </FieldText>
          )}
        </InputContainer>
      </FormRow>
      <FormRow singleLabel isEditing={dirty}>
        {dirty ? (
          <React.Fragment>
            <InputContainer key={3}>
              <LabelRow>
                <Label>
                  Date of birth<Required />
                </Label>
              </LabelRow>
              <Dropdown
                options={options.month}
                placeholder="Month"
                error={month.error}
                showError={payForm && !month.valid}
                value={month.edited ? month.value : selected.month}
                onChange={onChangeDropdown("month")}
              />
              {month.edited &&
                !month.valid &&
                !month.isActive && <ErrorMessage>{month.error}</ErrorMessage>}
            </InputContainer>
            <InputContainer key={4}>
              <Dropdown
                placeholder="Day"
                options={options.day}
                error={day.error}
                showError={payForm && !day.valid}
                value={day.edited ? day.value : selected.day}
                onChange={onChangeDropdown("day")}
              />
              {day.edited &&
                !day.valid &&
                !day.isActive && <ErrorMessage>{day.error}</ErrorMessage>}
            </InputContainer>
            <InputContainer key={5}>
              <Dropdown
                placeholder="Year"
                error={year.error}
                showError={payForm && !year.valid}
                options={options.year}
                value={ageYear}
                onChange={onChangeDropdown("year")}
              />
            </InputContainer>
            {!payForm && birthday.error &&
              <ErrorMessage>{birthday.error}</ErrorMessage>
            }
          </React.Fragment>
        ) : (
          <InputContainer>
            <LabelRow>
              <Label>
                Birthday<Required />
              </Label>
            </LabelRow>
            <FieldText>
              {formatDate(day, month, year, selected, birthdayNeeded)}
            </FieldText>
          </InputContainer>
        )}
      </FormRow>
    </React.Fragment>
  )
}

export { Basic as default }



// WEBPACK FOOTER //
// ./assets/account/components/forms/Basic.js